import { render, staticRenderFns } from "./HvSection.vue?vue&type=template&id=84a53a3a"
import script from "./HvSection.vue?vue&type=script&lang=js"
export * from "./HvSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports